<template>
  <main-template>
    <v-row>
      <v-col>
        <h1 :id="'titulo-plano'">
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planos' })"
            :id="'btn-voltar-planos'"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Semestral
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          depressed
          color="primary"
          @click="() => [visualizarPdf(plano.id), (dialogPdf = true)]"
          :id="'btn-visualizar-pdf'"
        >
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="" :id="'label-professor'">Professor</label>
            <v-input :id="'input-professor'">
              {{ plano.gestao_de_aula.professor ? plano.gestao_de_aula.professor.nome : "- - - " }}
            </v-input>

            <label for="" :id="'label-turma'">Turma</label>
            <v-input :id="'input-turma'">
              {{ plano.gestao_de_aula.turma ? plano.gestao_de_aula.turma.descricao : "- - - " }}
            </v-input>

            <label for="" :id="'label-disciplina'">Disciplina</label>
            <v-input :id="'input-disciplina'">
              {{ plano ? plano.disciplina.descricao : "- - - " }}
            </v-input>

            <label for="" :id="'label-data-lancamento'">Data lançamento</label>
            <v-input :id="'input-data-lancamento'">
              <v-chip>
                {{
                  plano ? plano.created_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="" :id="'label-ultima-atualizacao'">Ultima atualização</label>
            <v-input :id="'input-ultima-atualizacao'">
              <v-chip>
                {{
                  plano ? plano.updated_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox
              v-model="seriesSelecionadas"
              chips
              label="Series"
              multiple
              readonly
              :id="'combobox-series'"
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label for="" :id="'label-status'">Status</label>
                <e-situacao-plano :plano="plano" v-on:update="listarPlano" :id="'situacao-plano'" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>

                <label for="" :id="'label-semestre'">Semestre</label>
                <v-input :id="'input-semestre'">
                  {{ plano.semestre ? plano.semestre.descricao : "Sem Descrição" }}
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="" :id="'label-unidades-tematicas'"
                  >UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</label
                >
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.tematica ? plano.tematica : '- - -'"
                  :id="'textarea-unidades-tematicas'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- Conteúdo | Assunto | Objetos de conhecimento  -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-objetos-conhecimento'">OBJETOS DO CONHECIMENTO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.objeto_conhecimento ? plano.objeto_conhecimento : '- - -'"
                  :id="'textarea-objetos-conhecimento'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-habilidades'">HABILIDADES</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.habilidades ? plano.habilidades : '- - -'"
                  :id="'textarea-habilidades'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label :id="'label-metodologia'">METODOLOGIA</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.metodologia ? plano.metodologia : '- - -'"
                  :id="'textarea-metodologia'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- RECURSOS DIDÁTICOS -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-recursos-didaticos'">RECURSOS DIDÁTICOS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.recursos_didaticos ? plano.recursos_didaticos : '- - -'"
                  :id="'textarea-recursos-didaticos'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- AVALIAÇÃO DA APRENDIZAGEM -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-avaliacao-aprendizagem'">AVALIAÇÃO DA APRENDIZAGEM</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.avaliacao_aprendizagem ? plano.avaliacao_aprendizagem : '- - -'"
                  :id="'textarea-avaliacao-aprendizagem'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- REFERÊNCIAS -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-referencias'">REFERÊNCIAS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.referencias ? plano.referencias : '- - -'"
                  :id="'textarea-referencias'"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira
      :dialog="dialogPdf"
      :pdf="pdf"
      @update="fecharModal"
      :tipo-plano="tipoPlano"
      :id="'modal-carteira'"
    />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialogPdf: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      habilidadeSelecionadas: [],
      recursosSelecionados: [],
      avaliacoesSelecionadas: [],
      duvidasSelecionadas: [],
    };
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  computed: {
    tipoPlano() {
      return this.plano?.bimestre ? "Bimestral" : "Semestral";
    },
  },

  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        this.plano = await this.$services.planosService.showSemestral(this.plano_id);
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfSemestral(planoId);
    },
    fecharModal() {
      this.pdf = null;
      this.dialogPdf = false;
    },
  },
};
</script>

<style></style>
